import * as plansTypes from "../actions/types/plans";
const initialState = {
  plans: null,
  plan: null,
  plansComparative: null,
  loading: false,
  success: false
};
export const plansReducer = (state = initialState, action) => {
  switch (action.type) {
    case plansTypes.GET_PLANS_LOADING:
      return { ...state, loading: action.payload.loading };
    case plansTypes.GET_PLANS_SUCCESS:
      return {
        ...state,
        plans: action.payload.plans,
        loading: action.payload.loading,
        success: action.payload.success
      };
    case plansTypes.GET_PLANS_FAILED:
      return {
        ...state,
        loading: action.payload.loading,
        success: action.payload.success
      };

    case plansTypes.GET_PLANS_BY_ID_LOADING:
      return { ...state, loading: action.payload.loading };
    case plansTypes.GET_PLANS_BY_ID_SUCCESS:
      return {
        ...state,
        plan: action.payload.plan,
        loading: action.payload.loading,
        success: action.payload.success
      };
    case plansTypes.GET_PLANS_BY_ID_FAILED:
      return {
        ...state,
        loading: action.payload.loading,
        success: action.payload.success
      };

    case plansTypes.GET_PLANS_COMPARATIVE_LOADING:
      return { ...state, loading: action.payload.loading };
    case plansTypes.GET_PLANS_COMPARATIVE_SUCCESS:
      return {
        ...state,
        plansComparative: action.payload.plansComparative,
        loading: action.payload.loading,
        success: action.payload.success
      };
    case plansTypes.GET_PLANS_COMPARATIVE_FAILED:
      return {
        ...state,
        loading: action.payload.loading,
        success: action.payload.success
      };

    default:
      return { ...state };
  }
};
